import React from 'react';
import { MotifModal, MotifModalBody, MotifModalHeader, MotifIcon } from '@ey-xd/motif-react';
import { useRecoilValue } from 'recoil';
import { LOADING_MODAL_CONST } from '@constants/commonConstants';
import { Loading_Modal_State } from '@recoil/recoil';
import { actionIcInfo24px } from '@ey-xd/motif-react/assets/icons';
import {
  MessageParagraph,
  ModalHeaderContainer,
} from '@organisms/modals/styles/plOpportunityNameModal.styles';
import { isMobile } from 'react-device-detect';

const LoadingModal = () => {
  const showLoadingModal = useRecoilValue(Loading_Modal_State);

  const onModalClose = () => {
    // eslint-disable-next-line
  };

  return (
    <>
      <MotifModal
        variant="alt"
        show={showLoadingModal}
        style={{ width: '485px' }}
        size={isMobile ? 'sm' : 'md'}
        onClose={() => onModalClose()}
        focusTrapOptions={{ fallbackFocus: '[data-testid="modal-container"]' }}
      >
        <div data-testid="modal-container">
          {' '}
          <MotifModalHeader closeModalButton={true}>
            <ModalHeaderContainer>
              <MotifIcon
                style={{ color: '#ffffff', lineHeight: 1, paddingRight: '10px' }}
                src={actionIcInfo24px}
              />
              {LOADING_MODAL_CONST.HEADER_TITLE}
            </ModalHeaderContainer>
          </MotifModalHeader>
          <MotifModalBody>
            <MessageParagraph style={{ marginLeft: 11 }}>
              {' '}
              {LOADING_MODAL_CONST.DESCRIPTION1}
            </MessageParagraph>
          </MotifModalBody>
        </div>
      </MotifModal>
    </>
  );
};

export default LoadingModal;
